import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PerksOverview } from '@/components/practitioner/PerksOverview';

export const PractitionerPerksPage: React.FC = () => {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/practitioner">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Dashboard
          </Link>
        </Button>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Practitioner Perks</h1>
          <p className="text-muted-foreground">
            Exclusive rewards and benefits for your practice
          </p>
        </div>
      </div>

      <PerksOverview />
    </div>
  );
};